import React from 'react';
import cn from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import { isMultiImageDeviation } from '../../DeviationViews/_helpers';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';

import s from './FullscreenDeviationPage.scss';

export interface Props {
  deviation: PapiDeviation;
}

export const FullscreenPage: React.FC<Props> = ({ deviation }) => {
  // multi-image version has a slightly updated layout unfortunately
  const isMultiImage = isMultiImageDeviation(deviation);
  return (
    <div className={cn(s['root'], isMultiImage && s['multi-image'])}>
      <ArtStage deviation={deviation} />
      <ActionBar className={cn(isMultiImage && s['multi-image-actionbar'])} deviation={deviation} />
    </div>
  );
};

export default FullscreenPage;
